function openSearchbox() {
	const btn = document.getElementById("js-open-searchbox");
	const btnDesktop = document.getElementById("js-open-searchbox-desktop");
	const search = document.getElementById("js-searchbox");

	const mobileNav = document.getElementById("js-navigation");
	const btnNav = document.getElementById("js-mobile-btn");
	const nav = document.getElementById("js-navigation");
	const header = document.getElementById("header");

	if (!btn || !search || !btnDesktop || !header) return;

	// Gemeinsame Funktion für Klicks auf die Buttons
	function toggleSearch(e, triggerBtn) {
		e.stopPropagation(); // Klick nicht weiterreichen
		const isActive = triggerBtn.classList.toggle("active");
		search.classList.toggle("active");

		// Header-Klasse je nach Zustand setzen
		if (isActive) {
			header.classList.add("scrolled-down");
		} else if (!btn.classList.contains("active") && !btnDesktop.classList.contains("active")) {
			// Nur entfernen, wenn wirklich beide Buttons inaktiv sind
			header.classList.remove("scrolled-down");
		}

		// Falls Mobile-Menü offen ist → schließen
		if (mobileNav.classList.contains("active")) {
			btnNav.classList.remove("active");
			btnNav.classList.add("not-active");
			nav.classList.remove("active");
			document.body.classList.remove("menu-open");
		}
	}

	// Listener für beide Buttons
	btn.addEventListener("click", (e) => toggleSearch(e, btn));
	btnDesktop.addEventListener("click", (e) => toggleSearch(e, btnDesktop));

	search.addEventListener("click", function (e) {
		e.stopPropagation(); // Klick in der Searchbox nicht weiterreichen
	});

	document.addEventListener("click", function () {
		btn.classList.remove("active");
		btnDesktop.classList.remove("active");
		search.classList.remove("active");
		header.classList.remove("scrolled-down");
	});
}

export {openSearchbox};
